import _useMount from 'react-use/esm/useMount';
import {useEffect} from 'react';
import api from '@api';

import paths from '@paths';
import utils from '@utils';
import constants from '@constants';

export const useMount = (
  setLoading: (loading: boolean) => void,
  setIsAuthed: (authed: boolean) => void,
  actions: any
) => {
  _useMount(async () => {
    let result: boolean;

    try {
      // refreshTokeのセッション情報を取得
      await utils.amplify.getCurrentSession();

      // Me取得
      const {value} = await actions.me.updateMe();
      // クレジットカード登録済み且つ、スタンダードプランを契約しているユーザーのみ呼び出す
      if (value.me.customerId && value.me.plan === constants.PLAN.SAFETY) {
        // Stripeの支払い状況を更新
        api.payments.createUsageRecord({
          customerId: value.me.customerId,
          teamId: value.me.teamId,
        });
      }

      // viewport切替で縮小表示
      const content = 'width=1280';
      const viewport = document.getElementsByName('viewport')[0];
      viewport.setAttribute('content', content);

      result = true;
    } catch (err) {
      result = false;
    }

    setIsAuthed(result);
    setLoading(false);
  });
};

export const useUpdate = (
  setIsDisplay: React.Dispatch<React.SetStateAction<boolean>>,
  pathName: string
) => {
  useEffect(() => {
    // サイドバーを非表示する画面をtrueにする
    switch (pathName) {
      case paths.landing.main:
        setIsDisplay(false);
        break;
      case paths.reason.main:
        setIsDisplay(false);
        break;

      default:
        setIsDisplay(true);
    }
  });
};
